import { FingerNameEnum } from '@lmsConstants';

export class BiometricsModel {
  //Enroll Finger
  // clientId: number | any;
  idNumber: string;
  fingerName: FingerNameEnum | string;
  fingerImage1: string;
  fingerImage2: string;
  fingerImage3: string;
  fingerImage4: string;
  fingerImage5: string;
  fingerImage6: string;
  fingerImage7: string;
  fingerImage8: string;
  fingerImage9: string;
  fingerImage10: string;
  enrolledBy?: string;
  disabledAt: Date | string;
  disabledBy?: string;

  //User login name
  loginName?: string;
  branchName?: string;

  //Verify Intermediate
  fingerImage?: string;
  verifiedBy?: string;
  fingerVerified: boolean;
  verifiedMessage: string;


  //Disable Finger
  id: number | any;
  userName: string;

  skipReason: string;
  fingerId: number;
  userFingerId: number;
  cellNoExist: string;
  bmUserName: string;
  fingerImages: any[];

  //FAIS REP
  faisRepFingerId: number;
  faisRepUserName: string;
  isFaisRep: boolean;
  faisRep: boolean;
  branchEmail: string;
}

export class FingerEnrollResponse {
  errorCode?: string;
  errorMessage?: string;
}

export class FingerEnrollRequest {
  clientId?: number;
  fingerName: FingerNameEnum | string;
  fingerImage1?: string;
  fingerImage2?: string;
  fingerImage3?: string;
  fingerImage4?: string;
  enrolledBy: string;
  idNumber: string;
  skipReason?: string;
  branchName: string;
  loginName?: string;
}

export class FingerVerifyRequest {
  fingerId?: number;
  fingerName: FingerNameEnum | string;
  fingerImage?: string;
  verifiedBy: string;
  idNumber: string;
  branchName: string;
}



export class FingerDisableRequest {
  id: number;
  userName: string;
  idNumber: string;
  disabledBy: string;
}

export class UserFingerEnrollRequest {
  fingerName: string;
  fingerImage1: string;
  fingerImage2: string;
  fingerImage3: string;
  fingerImage4: string;
  fingerImage5: string;
  fingerImage6: string;
  fingerImage7: string;
  fingerImage8: string;
  fingerImage9: string;
  fingerImage10: string;
  enrolledBy?: string;
  disabledAt: Date;
  disabledBy?: string;

  //User login name
  loginName?: string;
  branchName?: string;
  faisRep: boolean;
}

export interface CustomerEnrollmentEntity {
  id?: number;
  idNumber?: string;
  userName?: string;
  fingerName?: FingerNameEnum | string;
  fmd?: string;
  created?: string;
  enrolledBy?: string;
  disabledAt?: string | Date | null; // Added null here if required across both
  disabledBy?: string;
  branchName?: string;
  faisRep?: boolean;
}

export class UserFingerVerifyRequest implements CustomerEnrollmentEntity {
  id?: number;  
  fingerId?: number;
  fingerName?: FingerNameEnum | string;
  fingerImage?: string;
  verifiedBy?: string;
  userName?: string;
  loginName?: string;
  branchName?: string;
  idNumber?: string;
  disabledAt?: string | Date | null = null; // Added '?' or a default value
}
